import { useState, useEffect } from 'react';

export const BREAKPOINTS = {
  TINY: 320,
  SMALL: 480,
  SMALLISH: 588,
  MEDIUM: 768,
  XMEDIUM: 992,
  LARGE: 1024,
  LARGISH: 1279,
  LARGER: 1380,
  XLARGE: 1440
};

export const useIsMobile = (breakpoint = BREAKPOINTS.MEDIUM): boolean => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const resizeListener = (): void => setWindowWidth(window.innerWidth);

    window.addEventListener('resize', resizeListener);

    resizeListener();

    return (): void => window.removeEventListener('resize', resizeListener);
  });

  return Boolean(windowWidth <= breakpoint);
};
